<template>
    <template
        v-if="modelValue"
    >
        <div
            v-if="modelValue.length === 1"
        >
            {{ modelValue[0] }}
        </div>
        <ul
            v-else
            class="list-style-none pa-0 ma-0"
        >
            <li
                v-for="value in modelValue"
            >
                {{ value }}
            </li>
        </ul>
    </template>
    <template
        v-else
    >
        <div class="text-center">&mdash;</div>
    </template>
</template>

<script lang="ts" setup>
    import type {
        ProductComparisonGroupMatrixCellValue
    } from '~/types';

    const props = defineProps<{
        modelValue: ProductComparisonGroupMatrixCellValue;
    }>();
</script>

<style lang="scss"></style>
